// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MNZls","field":"styles_field__X1iD2","fieldCol":"styles_fieldCol__3oBCj","diffCol":"styles_diffCol__7tnuD","diff":"styles_diff__rNY4E"};